import { useEffect, useRef } from "react";
import * as PIXI from "pixi.js";
import { Link } from "react-router-dom";

// IMAGES //
import buttonBrush1 from "../../assets/brush_stroke_button.png";
import buttonBrush2 from "../../assets/brush_stroke_button_02.png";

// CSS //
import "./brushButton.css";

const brushTextures = [
    buttonBrush1,
    buttonBrush2
]

export default function BrushButton({
    children,
    to,
    onClick,
    type = "button",
    color = 0x450f00,
    brushImage,
    brushMode = "stretch",
    className = ""
}) {
    const containerRef = useRef(null);

    const randomBrushImage = useRef(
        brushTextures[Math.floor(Math.random() * brushTextures.length)]
    );

    const selectedBrushImage = brushImage || randomBrushImage.current;

    useEffect(() => {
        let app;
        let destroyed = false;

        async function initPixi() {
            if (!containerRef.current) return;

            const width = containerRef.current.clientWidth;
            const height = containerRef.current.clientHeight;

            app = new PIXI.Application();

            await app.init({
                width,
                height,
                backgroundAlpha: 0,
                antialias: true
            });

            if (destroyed || !containerRef.current) {
                app.destroy(true);
                return;
            }

            containerRef.current.innerHTML = "";
            containerRef.current.appendChild(app.canvas);

            const texture = await PIXI.Assets.load(selectedBrushImage);

            if (destroyed || !app.stage) return;

            const sprite = new PIXI.Sprite(texture);

            sprite.anchor.set(0.5);
            sprite.position.set(width / 2, height / 2);

            // sprite.width = width;
            // sprite.height = height;

            if (brushMode === "contain") {
                const scale = Math.min(
                    width / texture.width,
                    height / texture.height
                );

                sprite.scale.set(scale);
            } else {
                sprite.width = width;
                sprite.height = height;
            }

            sprite.tint = color;
            sprite.alpha = 0.95;

            app.stage.addChild(sprite);
        }

        initPixi();

        return () => {
            destroyed = true;
            if (app) app.destroy(true);
        };
    }, [color, selectedBrushImage, brushMode]);

    const content = (
        <>
            <span className="brush-button-bg" ref={containerRef}/>
            <span className="brush-button-text">{children}</span>
        </>
    );

    if (to) {
        return (
            <Link
                className={`brush-button ${className}`}
                to={to}
                onClick={onClick}
            >
                {content}
            </Link>
        );
    }

    return (
        <button
            className={`brush-button ${className}`}
            type={type}
            onClick={onClick}
        >
            {content}
        </button>
    );
}